import { ICON__circle_info } from '@/assets/icons_fa';
import { ICON__info } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_grid2d from '@/locales/keys/i18n_grid2d.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../../../components/ui/UI_PRIMITIVE__tooltip';

interface Props {
  grid2d: DTO__grid2d;
}

export function GRID2D_BUTTON__show_image_info({ grid2d }: Props) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.GRID2D);

  const { user_settings } = use_slice_user(['user_settings']);

  const total_images = useMemo(() => get_total_images(), [grid2d]);
  /*
   * STATE
   */

  const { ui_grid2d__show_image_info } = user_settings;

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */
  async function onClick(event: React.MouseEvent<HTMLElement>): Promise<void> {
    if (is_loading) return;

    set_is_loading(true);

    let settings_new = user_settings.clone({ ui_grid2d__show_image_info: !ui_grid2d__show_image_info });

    await dispatch(REMOTE__user_settings_update(settings_new));

    set_is_loading(false);
  }

  /*
   * METHODS
   */

  function is_disabled(): boolean {
    return is_loading;
  }

  function get_total_images() {
    let out = grid2d.cells__get_loaded().filter(cell => !cell.hash_sha256_content.is_empty_hash_sha256()).length;

    return out;
  }

  /*
   * HTML
   */

  if (total_images === 0) return null;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_grid2d.buttons.download_images.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={ui_grid2d__show_image_info ? ICON__circle_info : ICON__info}
        disabled={is_disabled()}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
      />
    </UI_PRIMITIVE__tooltip>
  );
}
